import styled from "styled-components";

export const ContainerModal = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.white};
	border-radius: 8px;
	padding: 1rem;
	width: 650px;

	h6 {
		font-weight: bold;
		color: #000;
	}
`;

export const AreaButtons = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
`;

export const ContainerContentView = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	span {
		font-weight: bold;
		font-size: 0.95rem;
		color: #000;
	}
`;
